import React, { Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import zhCN from 'antd/es/locale/zh_CN'
import { ConfigProvider } from 'antd'
import { useTranslation } from 'react-i18next'
import PrivateRoute from '@/router/PrivateRoute'
import Login from '@/pages/login'
import IndexPage from '@/pages/indexPage'
import BigScreen from '@/pages/bigScreen'
import BigScreen2 from '@/pages/bigScreen2'
import Charts from '@/pages/charts'
import TablePage1 from '@/pages/table1'
import Table1Edit from '@/pages/table1Mana/table1Edit'
import WorkGroupEdit from '@/pages/workgroupMana/workgroupEdit'
import KeyRoadMapEdit from '@/pages/keyRoadMap/keyRoadMapEdit'
import TablePage2 from '@/pages/table2'
import Table2Edit from '@/pages/table2Mana/table2Edit'
import Table2EditApply from '@/pages/table2Mana/table2EditApply'
import Table2EditApplyList from '@/pages/table2Mana/table2EditApplyList'
import Table2EditAppr from '@/pages/table2Mana/table2EditAppr'
import Table2Search from '@/pages/table2SearchAll'
import ClassificationEdit from '@/pages/table2Mana/classificationEdit'
import TechReviewProgressPage from '@/pages/techReviewProgress'
import AddTechReviewPage from '@/pages/processMana/addTechReview'
import techReviewMorePage from '@/pages/processMana/techReviewMore'
import SelectRelativeReview from '@/pages/processMana/selectRelativeReview'
import SelectRelativeReviewSelectPerson from '@/pages/processMana/SelectRelativeReviewSelectPerson'
import ReviewStar from '@/pages/processMana/reviewStar'
import ReviewStarTMT from '@/pages/processMana/reviewStarTMT'
import RelevantByFeedBackList from '@/pages/processMana/onlineReviewTMTLs'
import OrganList from '@/pages/organStructure/organList'
import TechnicalShelf from '@/pages/technicalShelf'
import LogListAll from '@/pages/logListAll'
import TechChangeStatus from '@/pages/techChangeStatus/techChangeStatus'
import TechChangeList from '@/pages/techChangeStatus/techChangeList'
import TechRelative from '@/pages/techRelative'
import TechRelativeAnalysis from '@/pages/techRelativeAnalysis'
import BuAndCtListMana from '@/pages/processMana/buAndCtListMana'
import ProdListMana from '@/pages/processMana/prodListMana'
import AddVote from '@/pages/reviewReport/addVote'
import VoteReport from '@/pages/reviewReport/reportInfo'
import Contribution from '@/pages/rag/contribution'
import TechTree from '@/pages/rag/techTree'
import NoPage from '@/pages/404'
import { clearStore } from '@/store/actions/tableEdit.action'
import { getTime } from '@/services/auth.service'
import ProposalBoard from '@/pages/ProposalBoard/index'

let sessionRequestMsg = ''
export const setSessionRequestMsg = (msg: string): void => {
    sessionRequestMsg = msg
}
export const getSessionRequestMsg = (): string => {
    return sessionRequestMsg
}

const Routes = ():any => {
    const dispatch = useDispatch()
    const { i18n } = useTranslation()
    const clearStorage = (): void => {
        localStorage.clear()
        dispatch(clearStore())
    }
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const clearCache = async () => {
        const { data } = await getTime()
        let timer: string | null
        if (data) {
            timer = data
        } else {
            timer = localStorage.getItem('timer')
        }
        console.log('timer: ', timer)
        // 老版本，马上清除一下
        if (!timer) {
            clearStorage()
            localStorage.setItem('timer', '' + new Date().getTime())
        } else {
            // 如果超出一个星期，则清除一下
            if ((new Date().getTime() - (+timer)) > 1000 * 60 * 60 * 24 * 7) {
                clearStorage()
                localStorage.setItem('timer', '' + new Date().getTime())
            }
            // 否则既没超出时间，也有缓存时间值，则不用处理
        }
    }
    return (
        <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
            <Router>
                <Suspense fallback={<div className="screen_loading">加载中...</div>}>
                    <Switch>
                        <Route path="/login" component={Login} />
                        <PrivateRoute path="/" component={IndexPage} exact />
                        <PrivateRoute path="/bigScreen" component={BigScreen} exact />
                        <PrivateRoute path="/bigScreen2" component={BigScreen2} exact />
                        <PrivateRoute path="/indexPage" component={IndexPage} />
                        <PrivateRoute path="/charts" component={Charts} exact />
                        <PrivateRoute path="/keyRoadMap" component={TablePage1} exact />
                        <PrivateRoute path="/table1Add" component={Table1Edit} />
                        <PrivateRoute path="/table1Edit" component={Table1Edit} />
                        <PrivateRoute path="/workgroupAdd" component={WorkGroupEdit} />
                        <PrivateRoute path="/keyRoadMapAdd" component={KeyRoadMapEdit} />
                        <PrivateRoute path="/keyRoadMapEdit" component={KeyRoadMapEdit} />
                        <PrivateRoute path="/projectInfo" component={TablePage2} exact />
                        <PrivateRoute path="/classificationAdd" component={ClassificationEdit} />
                        <PrivateRoute path="/projectInfoAdd" component={Table2Edit} />
                        <PrivateRoute path="/projectInfoEdit" component={Table2Edit} />
                        <PrivateRoute path="/projectInfoChangeApply" component={Table2EditApply} />
                        <PrivateRoute path="/projectInfoChangeApplyList" component={Table2EditApplyList} />
                        <PrivateRoute path="/projectInfoChangeAppr" component={Table2EditAppr} />
                        <PrivateRoute path="/projectInfoView" component={Table2Edit} />
                        <PrivateRoute path="/projectInfoSearch" component={Table2Search} />
                        {/* <PrivateRoute path="/progress" component={ProgressPage} /> */}
                        <PrivateRoute path="/techReviewProgress" component={TechReviewProgressPage} />
                        {/* <PrivateRoute path="/progressAdd" component={AddProgressPage} /> */}
                        {/* <PrivateRoute path="/progressEdit" component={AddProgressPage} /> */}
                        <PrivateRoute path="/techReviewAdd" component={AddTechReviewPage} />
                        <PrivateRoute path="/techReviewEdit" component={AddTechReviewPage} />
                        <PrivateRoute path="/techReviewMore" component={techReviewMorePage} />
                        {/* <PrivateRoute path="/relevant" component={SelectRelative} /> */}
                        <PrivateRoute path="/relevantReview" component={SelectRelativeReview} />
                        <PrivateRoute path="/relevantReviewSelectPerson" component={SelectRelativeReviewSelectPerson} />
                        <PrivateRoute path="/reviewStar" component={ReviewStar} />
                        <PrivateRoute path="/reviewStarTMT" component={ReviewStarTMT} />
                        <PrivateRoute path="/relevantByFeedBackList" component={RelevantByFeedBackList} />
                        <PrivateRoute path="/organList" component={OrganList} />
                        <PrivateRoute path="/viewLogList" component={LogListAll} />
                        <PrivateRoute path="/techChangeStatus" component={TechChangeStatus} />
                        <PrivateRoute path="/techChangeList" component={TechChangeList} />
                        <PrivateRoute path="/techRelative" component={TechRelative} />
                        <PrivateRoute path="/technicalShelf" component={TechnicalShelf} />
                        <PrivateRoute path="/techRelativeAnalysis" component={TechRelativeAnalysis} />
                        <PrivateRoute path="/buAndCtListMana" component={BuAndCtListMana} />
                        <PrivateRoute path="/prodListMana" component={ProdListMana} />
                        <PrivateRoute path="/addVote" component={AddVote} />
                        <PrivateRoute path="/voteReport" component={VoteReport} />
                        <PrivateRoute path="/contribution" component={Contribution} />
                        <PrivateRoute path="/proposalBoard" component={ProposalBoard} />
                        <PrivateRoute path="/techTree" component={TechTree} />
                        <Route component={NoPage} />
                    </Switch>
                </Suspense>
            </Router>
        </ConfigProvider>
    )
}

export default Routes
